<template>
	<b-row>
		<b-col>
			<b-card>
				<div slot="header">
					<div class="justify-content-between d-flex">
						<div class="d-flex justify-content-center align-items-center">
							<h5 class="mb-0" style="white-space: nowrap">{{ $t('incomes.create.warehouse') }}</h5>
							<!--<b-form-radio-group-->
							<!--id="btn-radios-2"-->
							<!--v-model="selected"-->
							<!--:options="options"-->
							<!--class="ml-3"-->
							<!--buttons-->
							<!--button-variant="outline-primary"-->
							<!--size="sm"-->
							<!--name="radio-btn-outline"-->
							<!--style="white-space: nowrap;"-->
							<!--&gt;</b-form-radio-group>-->
						</div>

						<div class="d-flex">
							<b-row class="d-flex justify-content-end mr-1">
								<b-col v-if="selected=='sklad' && Object.keys(stats).length > 0 && whActiveTab == 0">
									<b-button variant="outline-dark" @click="$router.push('/warehouse-management/warehouses/prices')">
										<span class="fa fa-print"><span class="ml-2">{{ $t('incomes.create.prices')}}</span></span>
									</b-button>
								</b-col>
								<b-col v-if="selected=='sklad' && Object.keys(stats).length > 0 && whActiveTab == 0">
									<b-button @click="excelExport('tblData')" variant="primary" :disabled="loading">
										<i class="fa fa-download"></i> Excel
									</b-button>
								</b-col>
								<b-col>
									<b-button @click="$refs.myFilter.accept()" :disabled="loading" class="pull-right"
											  variant="primary">{{ $t('apply') }}
									</b-button>
								</b-col>
							</b-row>
							<div v-if="selected=='sklad' && whActiveTab == 0" class="card-header-actions"
								 style="display: flex;justify-content: flex-end;">
							</div>
						</div>
					</div>
				</div>
				<b-card-body>
					<FilterWarehouse
						:departments="myDepartments"
						@filter="filter"
						ref="myFilter"
						:loading="loading"
					/>
					<b-tabs v-model="whActiveTab">
						<b-tab title="по цене" active>
							<!-- <b-row v-if="emptyTable" class="">
								<b-col v-if="Object.keys(stats).length === 0" class="myContainer">
									<b-alert variant="danger" v-if="!loading" show>Нет доступных данных</b-alert>
									<div v-if="loading" class="spinner-wrapper">
										<b-spinner variant="primary"></b-spinner>
									</div>
								</b-col>
							</b-row> -->
							<div v-if="selected=='sklad'" class="generalTableClass myContainer">
								<div v-if="loading" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
								<table class="table b-table table-striped" size="xs" id="tblData"
									   v-if="Object.keys(stats).length !== 0">
									<template v-for="(key,item,index) in stats">
										<template v-if="index === 0">
											<tr :key="index">
												<th :colspan="lengthOfColumn()" rowspan="2">&nbsp;</th>
												<th scope="col" :colspan="isAdmin?5:3"
													class="textAlignCenter">
													<span v-for="(value, refFieldKey) in depsName" :key="refFieldKey">
														<span>{{ value.name }} </span>
														<span style="margin-left: 17px;" v-if="value.name">    </span>
													</span>
												</th>
											</tr>
											<tr :key="index + 'second'">
												<template v-for="(value, refFieldKey) in refField">
													<th class="textAlignCenter" :key="refFieldKey">
														{{
															value.totalCount |
																currency({
																symbol: '', fractionCount: 2, symbolPosition: 'back',
																thousandsSeparator: ' '
															})
														}}
													</th>
													<th v-if="value.totalSumOfIncomeUzs > 0 && isAdmin" colspan="2"
														class="textAlignCenter" :key="refFieldKey + 'second'">
														{{
															value.totalSumOfIncomeUzs | currency({
																symbol: value.currencyName,
																fractionCount: 2,
																symbolPosition: 'back',
																thousandsSeparator: ' '
															})
														}}
													</th>
													<!--<th v-else colspan="2" class="textAlignCenter"></th>-->

<!--													<th v-else colspan="2" class="textAlignCenter"></th>-->

													<th v-if="value.totalSumOfPriceUzs > 0" colspan="2"
														class="textAlignCenter">
														{{
															value.totalSumOfPriceUzs | currency({
																symbol: value.currencyName,
																fractionCount: 2,
																symbolPosition: 'back',
																thousandsSeparator: ' '
															})
														}}
													</th>
													<th v-else colspan="2" class="textAlignCenter"></th>
												</template>
											</tr>
										</template>
										<template v-if="index === 0">
											<tr>
												<th v-for="column in columns" v-if="column.visible"
													rowspan="2"
													style="vertical-align: middle;"
													:class="[column.key === 'id' ? 'textAlignCenter' : '', column.key === 'name' ? 'whTableColumnName' : '']"
												>
													{{ column.label }}
												</th>
												<template v-for="(key,value) in refField">
													<th class="textAlignCenter" rowspan="2"
														style="vertical-align: middle;">
														{{ $t('sale.kol-vo') }}
													</th>
													<th v-if="isAdmin" class="textAlignCenter" colspan="2">{{
															$t('warehouse.table.tableIncome')
														}}
													</th>
													<th class="textAlignCenter" colspan="2">{{
															$t('warehouse.table.tableRetail')
														}}
													</th>
												</template>
											</tr>
											<tr>
												<template v-for="(key,value) in refField">
													<th class="textAlignCenter">{{
															$t('warehouse.table.incomeUzs')
														}}
													</th>
													<th v-if="isAdmin" class="textAlignCenter">
														{{ $t('warehouse.table.totalIncomeUzs') }}
													</th>
													<th v-if="isAdmin" class="textAlignCenter">{{
															$t('warehouse.table.priceUzs')
														}}
													</th>
													<th class="textAlignCenter">{{
															$t('warehouse.table.totalPriceUzs')
														}}
													</th>
												</template>
											</tr>
										</template>
										<template>
											<tr style="background-color: gainsboro">
												<td colspan="80" class="textAlignCenter"><b>{{ item }}</b></td>
											</tr>
										</template>

										<template>
											<tr v-for="(item, index) in key">
												<template v-if="Object.keys(stats).length !== 0">
													<td v-for="column in columns" v-if="column.visible"
														:class="[column.key === 'id' ? 'textAlignCenter' : '', column.key === 'name' ? 'whTableColumnName' : '', column.key === 'artikul' ? 'artikulClass' : '',column.key === 'barcodeString' ? 'barcodes' : '',]"
														@click="forClick(item)"
														class="horverCourse">
														<template @click="forClick" v-if="column.key === 'id'">
															{{ index + 1 }}
														</template>
														<template @click="forClick" v-else>{{
																item[column.key]
															}}
														</template>
													</td>

													<!--													<template>-->
													<!--													<pre>{{item}}</pre>-->
													<!--													</template>-->

													<template v-for="(dep,idx) in refField">
														<td v-html="$options.filters.currency(returnValueOfDep(dep.name,item.deps,idx,'inventory'), {symbol: '', fractionCount: 2})"
															class="textAlignCenter"></td>

														<td v-if="item.deps && isAdmin"
															v-html="$options.filters.currency(item.deps[dep.name].incomeUzs, {symbol: dep.currencyName, fractionCount: 2})"
															class="textAlignCenter"></td>
														<!--<td v-else-->
														<!--class="textAlignCenter"></td>-->

														<td v-if="item.deps && isAdmin"
															v-html="$options.filters.currency(item.deps[dep.name].incomeUzs * item.deps[dep.name].inventory, {symbol: dep.currencyName, fractionCount: 2})"
															class="textAlignCenter"></td>
														<!--<td v-else-->
														<!--class="textAlignCenter"></td>-->

														<td v-if="item.deps"
															v-html="$options.filters.currency(item.deps[dep.name].priceUzs, {symbol: dep.currencyName, fractionCount: 2})"
															class="textAlignCenter"></td>
														<td v-else
															class="textAlignCenter"></td>

														<td v-if="item.deps"
															v-html="$options.filters.currency(item.deps[dep.name].priceUzs * item.deps[dep.name].inventory, {symbol: dep.currencyName, fractionCount: 2})"
															class="textAlignCenter"></td>
														<td v-else
															class="textAlignCenter"></td>
													</template>
												</template>
											</tr>

										</template>

									</template>

								</table>
								<!-- EMPTY TABLE BEGIN -->
								<table class="table b-table table-striped" size="xs" id="tblData" v-else>
									<template v-for="(key,item,index) in {'NO DATA': [{}]}">
										<template v-if="index === 0">
											<tr :key="index">
												<th :colspan="lengthOfColumn()" rowspan="2">&nbsp;</th>
												<th scope="col" :colspan="isAdmin?7:5"
													class="textAlignCenter">
													<span v-for="(value, refFieldKey) in depsName" :key="refFieldKey">
														<span>{{ value.name }} </span>
														<span style="margin-left: 17px;" v-if="value.name">    </span>
													</span>
												</th>
											</tr>
											<tr :key="index + 'second'">
												<template v-for="(value, refFieldKey) in refField">
													<th class="textAlignCenter" :key="refFieldKey">
														{{
															value.totalCount |
																currency({
																symbol: '', fractionCount: 2, symbolPosition: 'back',
																thousandsSeparator: ' '
															})
														}}
													</th>
													<th v-if="value.totalSumOfIncomeUzs > 0 && isAdmin" colspan="2"
														class="textAlignCenter" :key="refFieldKey + 'second'">
														{{
															value.totalSumOfIncomeUzs | currency({
																symbol: value.currencyName,
																fractionCount: 2,
																symbolPosition: 'back',
																thousandsSeparator: ' '
															})
														}}
													</th>
													<th v-else-if="isAdmin" colspan="2" class="textAlignCenter"></th>

													<th v-else colspan="2" class="textAlignCenter"></th>

													<th v-if="value.totalSumOfPriceUzs > 0" colspan="2"
														class="textAlignCenter">
														{{
															value.totalSumOfPriceUzs | currency({
																symbol: value.currencyName,
																fractionCount: 2,
																symbolPosition: 'back',
																thousandsSeparator: ' '
															})
														}}
													</th>
													<th v-else colspan="2" class="textAlignCenter"></th>
												</template>
											</tr>
										</template>
										<template v-if="index === 0">
											<tr>
												<th v-for="column in columns" v-if="column.visible"
													rowspan="2"
													style="vertical-align: middle;"
													:class="[column.key === 'id' ? 'textAlignCenter' : '', column.key === 'name' ? 'whTableColumnName' : '']"
												>
													{{ column.label }}
												</th>
												<template v-for="(key,value) in refField">
													<th class="textAlignCenter" rowspan="2"
														style="vertical-align: middle;">
														{{ $t('sale.kol-vo') }}
													</th>
													<th v-if="isAdmin" class="textAlignCenter" colspan="2">{{
															$t('warehouse.table.tableIncome')
														}}
													</th>
													<th class="textAlignCenter" colspan="2">{{
															$t('warehouse.table.tableRetail')
														}}
													</th>
												</template>
											</tr>
											<tr>
												<template>
													<th class="textAlignCenter">{{
															$t('warehouse.table.incomeUzs')
														}}
													</th>
													<th v-if="isAdmin" class="textAlignCenter">
														{{ $t('warehouse.table.totalIncomeUzs') }}
													</th>
													<th class="textAlignCenter">{{
															$t('warehouse.table.priceUzs')
														}}
													</th>
													<th class="textAlignCenter">{{
															$t('warehouse.table.totalPriceUzs')
														}}
													</th>
												</template>
											</tr>
										</template>
										<template>
											<tr style="background-color: gainsboro">
												<td colspan="80" class="textAlignCenter"><b>{{ item }}</b></td>
											</tr>
										</template>

										<!-- <template>
											<tr>
												<template>
													<td	class="textAlignCenter">Нет доступных данных</td>
												</template>
											</tr>
										</template> -->
									</template>
								</table>
								<!-- EMPTY TABLE END -->
							</div>
						</b-tab>


						<b-tab title="по кол-ву">
							<!-- GRID TABLE -->
							<items-list-grid
								:selectedDeps="depsName"
							></items-list-grid>
						</b-tab>


<!--						<b-tab title="по deps">-->
<!--							<pos-deps-->
<!--								:selectDeps="depsName"-->
<!--							>-->
<!--							</pos-deps>-->

<!--						</b-tab>-->
						<!--						<nav>-->
						<!--							<b-pagination :total-rows="total" :per-page="search.limit" v-model="search.page"-->
						<!--										  :prev-text="$t('pagination.prev')"-->
						<!--										  :next-text="$t('pagination.next')" hide-goto-end-buttons/>-->
						<!--						</nav>-->
					</b-tabs>
				</b-card-body>
				<div>
					<b-modal
						id="modal-xl"
						size="xl"
						hide-footer
						v-model="idForDep">
						<div
						>
							<div v-show="i.length>0" v-for="(i,idx) in itemDetails" :key="idx">
								{{ idx }}
								<!--    <pre>{{itemDetails}}</pre>-->
								<b-table v-if="i.length>0"

										 class="generalTableClass print-size"
										 :filter="filter"
										 :items="i"
										 responsive="sm"
										 :fields="fields">
									<template slot="number" slot-scope="data">
										<strong>{{ data.index + 1 }}</strong>
									</template>
								</b-table>
							</div>

							<strong></strong>
						</div>
					</b-modal>
				</div>
			</b-card>
		</b-col>
	</b-row>

</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import FilterWarehouse from "./blocks/Filter";
import ItemsListGrid from './blocks/ItemsListGrid';
import posDeps from './blocks/poDeps';
import VisibleColumns from "../goods/blocks/VisibleColumns";
import WhDocument from "../../../services/wh-document.service"
import {TokenService} from "../../../services/storage.service"

export default {
	name: 'Index',
	components: {
		FilterWarehouse,
		VisibleColumns,
		TokenService,
		ItemsListGrid,
		posDeps
	},

	computed: {
		...mapGetters('departments', [
			'myDepartments'
		]),
		...mapState(['isAdmin']),
		...mapState('warehouse', ['loading']),
		...mapState('warehouse', ['fields']),
		...mapState('saveTableOptions', ['tablesInStore']),
		...mapState('warehouse', {
			'stats': 'filteredItems',
			'statsBalance': 'itemBalance'
		}),
		formatted() {
			const indexs = Object.keys(this.priceStats);
			const formatted = [];

			indexs.map(index => {
				formatted.push({
					name: index,
					items: this.priceStats[index]
				});
			});

			return formatted;
		}
	},

	methods: {
		async forClick(item) {
			let arr = this.$refs.myFilter.filter.departmentId;
			if (arr) {
				let depIds = arr.map(e => e.id);
				await WhDocument.forIdsent(depIds, item.id).then(res => {
					this.itemDetails = res.data
				})
			}
			this.idForDep = true
		},
		openZayavka(item) {
		},
		checkedItems(id) {
			this.checkedNames.push(id)
		},
		paginate(index, depId, page_number) {
			let dep = this.pageDep.find(el => {
				return el.depId == depId;
			});
			// --page_size;
			return dep ? (page_number * (dep.page - 1)) + index + 1 : (page_number * (1 - 1)) + index + 1;
		},
		currentPageMethod(depId) {
			let dep = this.pageDep.find(el => {
				return el.depId == depId;
			});
			return dep ? dep.page : 1;
		},
		// paginateByDep(event, depId) {
		// 	this.pageDep.forEach(el => {
		// 		if (el.depId == depId) {
		// 			el.page = event;
		// 		}
		// 	})
		// 	let obj = {
		// 		departments: this.pageDep,
		// 		selected: this.selected,
		// 		link: [],
		// 	};
		//
		// 	this.getBalancePrice(obj)
		// 	this.itemBalance(obj)
		//
		// },
		...mapActions('departments', ['fetchMyDepartments']),
		...mapActions('warehouse', ['getBalancePrice', 'itemBalance', 'getItemsListForWhGrid']),

		async filter($event) {
			let obj = {};
			this.pageDep = [];
			if ($event.depsId) {
				if ($event.depsId.depIds) {
					for (let i = 0; i < $event.depsId.depIds.length; i++) {
						let tempForDep = {
							page: this.search.page,
							limit: this.search.limit,
							depId: $event.depsId.depIds[i]
						}
						this.pageDep.push(tempForDep);
					}
					obj.pageDep = this.pageDep;
				}
			}

			this.refField = []
			if (!$event.empty) {
				this.depsName = $event.depNames
				this.depsName.forEach(el => {
					if (this.selected == 'sklad') {
						this.addRefFiled(el)
					}
				});
				this.emptyTable = true;
				$event.selected = this.selected;
				$event.departments = obj.pageDep;
				if (this.whActiveTab == 0) {
					await this.getBalancePrice($event);
				} else if (this.whActiveTab == 1) {
					await this.getItemsListForWhGrid($event);
				} else {
					await this.itemBalance($event)
				}

				/* CALCULATE TOTALCOUNT AND SUM FOR EACH DEPARTMENT */
				let keys = Object.keys(this.stats);

				if (keys[0] == 'MAGAZIN') {
					this.stats['MAGAZIN'].forEach(item => {
						Object.keys(item.deps).forEach(key => {
							let value = item.deps[key];
							this.refField.forEach(dep => {
								if (key == dep.name) {
									dep.totalCount += parseFloat(value.inventory);
									dep.totalSumOfIncomeUzs += parseFloat(value.incomeUzs) * parseFloat(value.inventory);
									dep.totalSumOfPriceUzs += parseFloat(value.priceUzs) * parseFloat(value.inventory);
									dep.totalSumOfPriceWholesale += parseFloat(value.priceWholesale) * parseFloat(value.inventory);
								}
							})
						});
					})
				}
				let keyBalane = Object.keys(this.statsBalance);
				if (keyBalane[0] == 'items') {
					this.statsBalance['items'].forEach(item => {
						let items = JSON.parse(item.deps);
						this.itemsDeps = items
						items.forEach(key => {
							this.refField.forEach(dep => {
								if (key.departmentname == dep.name) {
									if (key) {
										dep.totalCount += parseFloat(key.remaining ? key.remaining : '');
										dep.totalSumOfIncome_uzs += parseFloat(key.income_uzs ? key.income_uzs : '') * parseFloat(key.remaining ? key.remaining : '');
										dep.totalSumOfPrice_uzs += parseFloat(key.price_uzs ? key.price_uzs : '') * parseFloat(key.remaining ? key.remaining : '');
									}
								}
							})
						});
					})
				}
			} else {
				this.$store.commit('warehouse/setFilteredItems', []);
				this.$store.commit('warehouse/setItemBalance', []);
				this.emptyTable = false
			}
		},

		lengthOfColumn() {
			let col = this.columns.filter(column => {
				if (column.visible) {
					return column
				}
			});
			return col.length
		},

		columnListener($event) {
			this.columns = $event
		},
		addRefFiled(depNameAndCurrency) {
			if (this.refField.findIndex(el => {
				return el.name == depNameAndCurrency.name
			}) === -1) {
				let temp = {
					name: depNameAndCurrency.name,
					currencyName: depNameAndCurrency.currencyName,
					totalCount: 0,
					totalSumOfIncomeUzs: 0,
					totalSumOfPriceUzs: 0,
					totalSumOfIncome_uzs: 0,
					totalSumOfPrice_uzs: 0,
					totalSumOfPriceWholesale: 0
				};
				this.depsName.push(temp.name);
				if (this.selected == 'sklad') {
					if (this.refField.length < 1 || this.refField.length > 1) {
						this.refField.push(temp)
					}
				}
			}
		},

		returnValueOfDep(dep, itemDeps, index, what, depCurrencyName) {
			if (itemDeps !== undefined) {
				if (itemDeps[dep] && index === this.refField.findIndex(el => {
					return el.name == dep
				})) {
					if (what === 'inventory' || what === 'remaining') {
						return itemDeps[dep][what];
					} else {
						return itemDeps[dep][what] * itemDeps[dep]['inventory' || 'remaining'];
					}

				} else {
					if (what === 'inventory' || what === 'remaining') {
						return 0;
					} else {
						return `0 ${depCurrencyName}`;
					}
				}
			}
		},
		excelExport(tableID, filename = '') {

			var downloadLink;

			var dataType = 'text/xls;charset=UTF-8';
			//var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename ? filename + '.xls' : 'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if (navigator.msSaveOrOpenBlob) {
				var blob = new Blob(['\ufeff', tableSelect], {
					encoding: "utf-8",
					type: dataType
				});
				navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				// Create a link to the file
				downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

				// Setting the file name
				downloadLink.download = filename;

				//triggering the function
				downloadLink.click();
			}

		},

	},

	data() {
		return {
			itemsDeps: null,
			show: false,
			itemDetails: [],
			selectedDep: [],
			idForDep: false,
			whActiveTab: 0,
			isChecked: false,
			checkedNames: [],
			pageDep: [],
			statusCheck: [],
			currentPage: 1,
			search: {
				page: 1,
				limit: 20
			},
			perPage: 20,
			selected: 'sklad',
			options: [
				{text: this.$t('sidebar.warehouse-management.items-section1'), value: 'sklad'},
				{text: this.$t('sidebar.warehouse-management.items-section2'), value: 'sklad-5'},

			],
			depName: [],
			priceStats: {},
			emptyTable: false,
			depsName: [],
			depsName2: [],
			refField: [],
			allTotal: [],
			columns: [
				{
					key: 'id',
					label: '№',
					visible: true,
					changebale: true
				},
				{
					key: 'barcode',
					label: this.$t('goods.special-barcode'),
					visible: true,
					changebale: true
				},
				{
					key: 'name',
					label: this.$t('goods.name'),
					visible: true,
					changebale: true
				},
				{
					key: 'barcodeString',
					label: this.$t('goods.barcode'),
					visible: true,
					changebale: true
				},
				{
					key: 'artikul',
					label: this.$t('goods.artikul'),
					visible: true,
					changebale: true
				},
				{
					key: 'color',
					label: this.$t('goods.color'),
					visible: false,
					changebale: true
				},
				{
					key: 'genderName',
					label: this.$t('goods.gender'),
					visible: false,
					changebale: true
				},
				{
					key: 'subName',
					label: TokenService.getDepartmentType() === 'SHOP' ? this.$t('client.create.customer') : 'Подкатегория 1',
					visible: true,
					changebale: true
				},
				{
					key: 'brandName',
					label: this.$t('goods.brand'),
					visible: false,
					changebale: true
				},
				{
					key: 'sub2Name',
					label: TokenService.getDepartmentType() === 'SHOP' ? this.$t('goods.category') : 'Подкатегория 2',
					visible: false,
					changebale: true
				},
				{
					key: 'sub3Name',
					label: TokenService.getDepartmentType() === 'SHOP' ? this.$t('goods.subcategory') : 'Подкатегория 3',
					visible: false,
					changebale: true
				},

			],
			loaderImg: {
				width: '80px',
				height: '80px',
			}
		}
	},

	mounted() {
		this.fetchMyDepartments();
		this.$store.commit('warehouse/setFilteredItems', []);
		this.$store.commit('warehouse/setItemBalance', [])
	},
	watch: {
		'selected': {
			handler() {
				this.depsName = [];
				this.refField = [];
				this.$refs.myFilter.setFilterToComponent();
			},
		},

	}
}
</script>

<style scoped>
.horverCourse:hover {
	cursor: pointer;
	color: #c0c0c0;
}

/*.width15_wordBreak {
	width: 14%;
}*/
.wrappedStyle {
	color: blue;
	font-weight: bold;
}

.myContainer {
	overflow-x: auto;
	white-space: nowrap;
	position: relative;
}

.alert {
	padding: 15px;
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}

.loaderImg {
	position: absolute;
	left: 44%;
	top: 44%;
	z-index: 1;
	border: 6px solid #f3f3f3;
	border-radius: 50%;
	border-top: 6px solid #0092D3;
	border-bottom: 6px solid #0092D3;
	width: 60px;
	height: 60px;
	-webkit-animation: spin 1.6s linear infinite;
	animation: spin 1.6s linear infinite;
}

@-webkit-keyframes spin {
	0% {
		-webkit-transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
	}
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.artikulClass {
	width: 20px;
}

.barcodes {
	width: 25px;
}
</style>
